import {Component, EventEmitter, OnInit, Output, forwardRef, Input} from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS
} from '@angular/forms';
import {HhgBillOfLadingService} from 'src/app/services/hhg-bill-of-lading/hhg-bill-of-lading.service';
import {tap} from 'rxjs/operators';
import {HhgBolPackagesEntity} from 'src/app/shared/common-components/common-structure';
import AppConstants from 'src/app/shared/common-components/AppConstants';

@Component({
    selector: 'app-billoflading-shipment-information',
    templateUrl: './billoflading-shipment-information.component.html',
    styleUrls: ['./billoflading-shipment-information.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => BillofladingShipmentInformationComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => BillofladingShipmentInformationComponent),
            multi: true,
        }
    ],
    standalone: false
})
export class BillofladingShipmentInformationComponent implements ControlValueAccessor, OnInit {
  // @Output() clickContinue = new EventEmitter();
  @Input() routedFrom: any;
  @Input() selectedShipmentType: any;
  @Input() selectedVehicleType: any;
  shipmentInformationForm: UntypedFormGroup;
  isHHGSelected: boolean;
  isUABSelected: boolean;
  isPOVSelected: boolean;
  hhgHeader: 'HHG';
  uabHeader: 'UAB';
  povHeader: 'POV';
  packagesList: any[];
  shipmentTypeArray: any[];
  shipments: any[];
  package: any;
  isHHGFound: boolean;
  isUABFound: boolean;
  isPOVFound: boolean;
  ship: string;
  isinvoked: boolean;
  isShipmentRecordFound: boolean;
  hhgBolDetailsId: number;
  packagesMap: Map<string, HhgBolPackagesEntity> = new Map<string, HhgBolPackagesEntity>();
  unSelectedShipmentType: string;
  hhgBolPackagesEntity: HhgBolPackagesEntity;
  isHHGFoundAndSelected: boolean;
  isUABFoundAndSelected: boolean;
  isPOVFoundAndSelected: boolean;

  shipmentInformation$ = this.hhgBillOfLadingService.hhgBillOfLadingPackageDetail$
    .pipe(tap(PackageDetail => {
      this.packagesMap = new Map<string, HhgBolPackagesEntity>();
      const totalItems = PackageDetail.length;
      for (const shipmentPackagesMaster of PackageDetail) {
        this.packagesMap.set(shipmentPackagesMaster.shipmentType, shipmentPackagesMaster);
      }
      this.packagesList = [];
      const packagesFormArray = this.shipmentInformationForm.get('packages') as UntypedFormArray;

      const control = <UntypedFormArray>this.shipmentInformationForm.controls.packages;
      if (!(this.isinvoked)) {
        this.isinvoked = true;
        this.isHHGSelected = false;
        this.isPOVSelected = false;
        this.isUABSelected = false;
        if (PackageDetail.length === 0) {
          for (let i = 0; i < this.shipmentTypeArray.length; i++) {
            let shipmentTypeDescription = '';
            let packageKind = '';
            if (this.shipmentTypeArray[i] === 'HHG') {
              shipmentTypeDescription = 'USED HOUSEHOLD GOODS AND PERSONAL EFFECTS';
              packageKind = 'LOT';
            } else if (this.shipmentTypeArray[i] === 'HHG-UAB') {
              shipmentTypeDescription = 'UNACCOMPANIED AIR BAGGAGE';
              packageKind = 'PCS';
            } else if (this.shipmentTypeArray[i] === 'HHG-POV') {
              packageKind = 'POV';
              if (AppConstants.isNotNullCondition(this.selectedVehicleType)) {
                if (this.selectedVehicleType === 'Category I') {
                  shipmentTypeDescription = 'Less Than 300 CFt';
                } else if (this.selectedVehicleType === 'Category II') {
                  shipmentTypeDescription = 'Between 300 and 800 CFt';
                } else if (this.selectedVehicleType === 'Category III') {
                  shipmentTypeDescription = 'Exceeding 800 CFt';
                }
              }
            }
            control.push(
              this.fb.group({
                hhgBolDetailsId: new UntypedFormControl(this.hhgBolDetailsId),
                totalPieces: new UntypedFormControl(1),
                packageType: new UntypedFormControl(packageKind),
                packageLineNo: new UntypedFormControl(1),
                packageDescription: new UntypedFormControl(shipmentTypeDescription, Validators.required),
                additionalInfo: new UntypedFormControl(''),
                shipmentType: new UntypedFormControl(this.shipmentTypeArray[i])
              })
            );
          }
        } else if (this.shipmentTypeArray.length < PackageDetail.length) {
          this.unSelectedShipmentType = '';
          for (let i = 0; i < PackageDetail.length; i++) {
            for (let j = 0; j < this.shipmentTypeArray.length; j++) {
              if (this.shipmentTypeArray[j] === 'HHG') {
                this.isHHGSelected = true;
              } else if (this.shipmentTypeArray[j] === 'HHG-UAB') {
                this.isUABSelected = true;
                // this.isUABFoundAndSelected = true;
              } else if (this.shipmentTypeArray[j] === 'HHG-POV') {
                this.isPOVSelected = true;
              }
              if (PackageDetail[i].shipmentType === this.shipmentTypeArray[j]) {
                if (this.shipmentTypeArray[j] === 'HHG') {
                  this.isHHGSelected = true;
                  this.isHHGFoundAndSelected = true;
                } else if (this.shipmentTypeArray[j] === 'HHG-UAB') {
                  this.isUABSelected = true;
                  this.isUABFoundAndSelected = true;
                } else if (this.shipmentTypeArray[j] === 'HHG-POV') {
                  this.isPOVSelected = true;
                  this.isPOVFoundAndSelected = true;
                }
                control.push(
                  this.fb.group({
                    hhgBookPackagesId: new UntypedFormControl(PackageDetail[j].hhgBookPackagesId),
                    totalPieces: new UntypedFormControl(PackageDetail[j].totalPieces > 0 ? PackageDetail[j].totalPieces : 1),
                    packageType: new UntypedFormControl(PackageDetail[j].packageType && PackageDetail[j].packageType.length > 0
                      ? PackageDetail[j].packageType : 'LOT'),
                    packageLineNo: new UntypedFormControl(PackageDetail[j].packageLineNo > 0 ? PackageDetail[j].packageLineNo : 1),
                    shipmentType: new UntypedFormControl(PackageDetail[j].shipmentType),
                    packageDescription: new UntypedFormControl(PackageDetail[j].packageDescription, Validators.required),
                    additionalInfo: new UntypedFormControl(PackageDetail[j].additionalInfo)
                  })
                );

              } else {
                this.unSelectedShipmentType = PackageDetail[i].shipmentType;
              }
            }
            if (this.isHHGSelected === true && this.isHHGFoundAndSelected === false) {
              control.push(
                this.fb.group({
                  totalPieces: new UntypedFormControl(1),
                  packageType: new UntypedFormControl('LOT'),
                  packageLineNo: new UntypedFormControl(1),
                  packageDescription: new UntypedFormControl('', Validators.required),
                  additionalInfo: new UntypedFormControl(''),
                  shipmentType: new UntypedFormControl('HHG')
                })
              );
            }
            if (this.isUABSelected === true && this.isUABFoundAndSelected === false) {
              control.push(
                this.fb.group({
                  totalPieces: new UntypedFormControl(1),
                  packageType: new UntypedFormControl('PCS'),
                  packageLineNo: new UntypedFormControl(1),
                  packageDescription: new UntypedFormControl('', Validators.required),
                  additionalInfo: new UntypedFormControl(''),
                  shipmentType: new UntypedFormControl('HHG-UAB')
                })
              );
            }
            if (this.isPOVSelected === true && this.isPOVFoundAndSelected === false) {
              control.push(
                this.fb.group({
                  totalPieces: new UntypedFormControl(1),
                  packageType: new UntypedFormControl('POV'),
                  packageLineNo: new UntypedFormControl(1),
                  packageDescription: new UntypedFormControl('', Validators.required),
                  additionalInfo: new UntypedFormControl(''),
                  shipmentType: new UntypedFormControl('HHG-POV')
                })
              );
            }
            if (PackageDetail[i].shipmentType === 'HHG' && this.isHHGSelected === false) {
              const hhgBolPackagesEntity = new HhgBolPackagesEntity();
              this.hhgBolPackagesEntity = this.packagesMap.get(PackageDetail[i].shipmentType + '');
              this.hhgBillOfLadingService.deletePackage(this.hhgBolPackagesEntity.hhgBookPackagesId, this.hhgBolPackagesEntity)
                .subscribe(response => {

                });

            } else if (PackageDetail[i].shipmentType === 'HHG-UAB' && this.isUABSelected === false) {
              const hhgBolPackagesEntity = new HhgBolPackagesEntity();
              this.hhgBolPackagesEntity = this.packagesMap.get(PackageDetail[i].shipmentType + '');
              this.hhgBillOfLadingService.deletePackage(this.hhgBolPackagesEntity.hhgBookPackagesId, this.hhgBolPackagesEntity)
                .subscribe(response => {

                });

            } else if (PackageDetail[i].shipmentType === 'HHG-POV' && this.isPOVSelected === false) {
              const hhgBolPackagesEntity = new HhgBolPackagesEntity();
              this.hhgBolPackagesEntity = this.packagesMap.get(PackageDetail[i].shipmentType + '');
              this.hhgBillOfLadingService.deletePackage(this.hhgBolPackagesEntity.hhgBookPackagesId, this.hhgBolPackagesEntity)
                .subscribe(response => {

                });

            }
          }
        } else if (this.shipmentTypeArray.length > PackageDetail.length) {
          for (let i = 0; i < this.shipmentTypeArray.length; i++) {
            for (let j = 0; j < PackageDetail.length; j++) {
              if (this.shipmentTypeArray[i] === PackageDetail[j].shipmentType) {
                if (PackageDetail[j].shipmentType === 'HHG') {
                  this.isHHGSelected = true;
                } else if (PackageDetail[j].shipmentType === 'HHG-UAB') {
                  this.isUABSelected = true;
                } else if (PackageDetail[j].shipmentType === 'HHG-POV') {
                  this.isPOVSelected = true;
                }
                control.push(
                  this.fb.group({
                    hhgBookPackagesId: new UntypedFormControl(PackageDetail[j].hhgBookPackagesId),
                    //hhgBolDetailsId: new FormArray(PackageDetail[j].hhgBolDetailsId),
                    totalPieces: new UntypedFormControl(PackageDetail[j].totalPieces > 0 ? PackageDetail[j].totalPieces : 1),
                    packageType: new UntypedFormControl(PackageDetail[j].packageType && PackageDetail[j].packageType.length > 0
                      ? PackageDetail[j].packageType : 'LOT'),
                    packageLineNo: new UntypedFormControl(PackageDetail[j].packageLineNo > 0 ? PackageDetail[j].packageLineNo : 1),
                    shipmentType: new UntypedFormControl(PackageDetail[j].shipmentType),
                    packageDescription: new UntypedFormControl(PackageDetail[j].packageDescription, Validators.required),
                    additionalInfo: new UntypedFormControl(PackageDetail[j].additionalInfo)
                  })
                );
              }
            }
            if (this.shipmentTypeArray[i] === 'HHG' && this.isHHGSelected === false) {
              control.push(
                this.fb.group({
                  totalPieces: new UntypedFormControl(1),
                  packageType: new UntypedFormControl('LOT'),
                  packageLineNo: new UntypedFormControl(1),
                  packageDescription: new UntypedFormControl('', Validators.required),
                  additionalInfo: new UntypedFormControl(''),
                  shipmentType: new UntypedFormControl(this.shipmentTypeArray[i])
                })
              );
            } else if (this.shipmentTypeArray[i] === 'HHG-UAB' && this.isUABSelected === false) {
              control.push(
                this.fb.group({
                  totalPieces: new UntypedFormControl(1),
                  packageType: new UntypedFormControl('PCS'),
                  packageLineNo: new UntypedFormControl(1),
                  packageDescription: new UntypedFormControl('', Validators.required),
                  additionalInfo: new UntypedFormControl(''),
                  shipmentType: new UntypedFormControl(this.shipmentTypeArray[i])
                })
              );
            } else if (this.shipmentTypeArray[i] === 'HHG-POV' && this.isPOVSelected === false) {
              control.push(
                this.fb.group({
                  totalPieces: new UntypedFormControl(1),
                  packageType: new UntypedFormControl('POV'),
                  packageLineNo: new UntypedFormControl(1),
                  packageDescription: new UntypedFormControl('', Validators.required),
                  additionalInfo: new UntypedFormControl(''),
                  shipmentType: new UntypedFormControl(this.shipmentTypeArray[i])
                })
              );
            }


          }
        } else if (PackageDetail.length === this.shipmentTypeArray.length) {
          for (let i = 0; i < this.shipmentTypeArray.length; i++) {
            for (let j = 0; j < PackageDetail.length; j++) {
              if (this.shipmentTypeArray[i] === PackageDetail[j].shipmentType) {
                if (PackageDetail[j].shipmentType === 'HHG') {
                  this.isHHGSelected = true;
                } else if (PackageDetail[j].shipmentType === 'HHG-UAB') {
                  this.isUABSelected = true;
                } else if (PackageDetail[j].shipmentType === 'HHG-POV') {
                  this.isPOVSelected = true;
                }
                control.push(
                  this.fb.group({
                    hhgBookPackagesId: new UntypedFormControl(PackageDetail[i].hhgBookPackagesId),
                    totalPieces: new UntypedFormControl(PackageDetail[i].totalPieces > 0 ? PackageDetail[i].totalPieces : 1),
                    packageType: new UntypedFormControl(PackageDetail[i].packageType && PackageDetail[i].packageType.length > 0
                      ? PackageDetail[i].packageType : 'LOT'),
                    packageLineNo: new UntypedFormControl(PackageDetail[i].packageLineNo > 0 ? PackageDetail[i].packageLineNo : 1),
                    shipmentType: new UntypedFormControl(PackageDetail[i].shipmentType),
                    packageDescription: new UntypedFormControl(PackageDetail[i].packageDescription, Validators.required),
                    additionalInfo: new UntypedFormControl(PackageDetail[i].additionalInfo)
                  })
                );
              }
            }
            if (this.shipmentTypeArray[i] === 'HHG' && this.isHHGSelected === false) {
              control.push(
                this.fb.group({
                  totalPieces: new UntypedFormControl(1),
                  packageType: new UntypedFormControl('LOT'),
                  packageLineNo: new UntypedFormControl(1),
                  packageDescription: new UntypedFormControl('', Validators.required),
                  additionalInfo: new UntypedFormControl(''),
                  shipmentType: new UntypedFormControl(this.shipmentTypeArray[i])
                })
              );
            } else if (this.shipmentTypeArray[i] === 'HHG-UAB' && this.isUABSelected === false) {
              control.push(
                this.fb.group({
                  totalPieces: new UntypedFormControl(1),
                  packageType: new UntypedFormControl('PCS'),
                  packageLineNo: new UntypedFormControl(1),
                  packageDescription: new UntypedFormControl('', Validators.required),
                  additionalInfo: new UntypedFormControl(''),
                  shipmentType: new UntypedFormControl(this.shipmentTypeArray[i])
                })
              );
            } else if (this.shipmentTypeArray[i] === 'HHG-POV' && this.isPOVSelected === false) {
              control.push(
                this.fb.group({
                  totalPieces: new UntypedFormControl(1),
                  packageType: new UntypedFormControl('POV'),
                  packageLineNo: new UntypedFormControl(1),
                  packageDescription: new UntypedFormControl('', Validators.required),
                  additionalInfo: new UntypedFormControl(''),
                  shipmentType: new UntypedFormControl(this.shipmentTypeArray[i])
                })
              );
            }
          }
        }
      }
    }));

  constructor(private fb: UntypedFormBuilder, private hhgBillOfLadingService: HhgBillOfLadingService) {
    this.shipmentInformationForm = this.fb.group({
      packages: this.fb.array([this.createPackagesForm()])
    });
    this.shipmentInformationForm.valueChanges.subscribe(value => {
      this.onChange(value);
      this.onTouched();
    });
  }

  selectedShipmentTypes() {
    if (this.shipmentTypeArray.length > 0) {
      for (let i = 0; i < this.shipmentTypeArray.length; i++) {
        if (this.shipmentTypeArray[i] === 'HHG') {
          this.isHHGSelected = true;
        } else if (this.shipmentTypeArray[i] === 'HHG-POV') {
          this.isPOVSelected = true;
        } else {
          this.isUABSelected = true;
        }
      }
    }
  }

  createPackagesForm(): UntypedFormGroup {
    return this.fb.group({
      hhgBookPackagesId: new UntypedFormControl(''),
      hhgBolDetailsId: new UntypedFormControl(''),
      packageLineNo: new UntypedFormControl(''),
      totalPieces: new UntypedFormControl(''),
      packageType: new UntypedFormControl(''),
      packageDescription: new UntypedFormControl(''),
      additionalInfo: new UntypedFormControl(''),
      shipmentType: new UntypedFormControl('')
    });
  }

  ngOnInit() {
    // pre-populate Shipment/Booking Types if any
    if (this.selectedShipmentType) {
      this.shipmentTypeArray = this.selectedShipmentType.split(' & ');
      for (let i = 0; i < this.shipmentTypeArray.length; i++) {
        this.shipments = this.shipmentTypeArray[i];
        if (this.shipmentTypeArray[i] === 'HHG') {
          this.isHHGSelected = true;
          this.hhgHeader = 'HHG';
        }
        if (this.shipmentTypeArray[i] === 'HHG-UAB') {
          this.isUABSelected = true;
          this.uabHeader = 'UAB';
        }
        if (this.shipmentTypeArray[i] === 'HHG-POV') {
          this.isPOVSelected = true;
          this.povHeader = 'POV';
        }
      }
    }
  }

  onChange: any = () => {
  }
  onTouched: any = () => {
  }

  get value(): any {
    return this.shipmentInformationForm.value;
  }

  set value(value: any) {
    this.shipmentInformationForm.setValue(value);
    this.onChange(value);
    this.onTouched();
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  writeValue(value: any) {
    if (value) {
      this.value = value;
    }
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  // communicate the inner form validation to the parent form
  validate(_: UntypedFormControl) {
    return this.shipmentInformationForm.valid ? null : {profile: {valid: false}};
  }
}
